import { useMyTimeWorkTime, useMyTimeWorkTimeWeeklyData } from "my-time/hooks";
import { timeConvert } from "my-time/utils/time-convert";

export const useWorkTimeLimits = ({
  contractCode,
  date,
  startTime,
  endTime,
  myTimeType,
}: {
  contractCode: string;
  date: Date;
  startTime: string;
  endTime: string;
  myTimeType: string;
}) => {
  const { data: workTimeWeeklyData } = useMyTimeWorkTimeWeeklyData({
    contractCode,
    date: date?.toISOString(),
  });

  const weeklyVoluntaryOvertimeLimit =
    workTimeWeeklyData?.weeklyVoluntaryOvertimeLimit * 60;

  const weeklyWorktimeLimit = workTimeWeeklyData?.weeklyWorktimeLimit * 60;

  const { data: workTimeData } = useMyTimeWorkTime({
    contractCode,
    startTime,
    endTime,
    myTimeType: myTimeType,
  });

  const initialValue = 0;
  const allTime = workTimeData?.reduce(
    (accumulator: number, currentValue: { workTime: number }) =>
      accumulator + currentValue.workTime,
    initialValue,
  );

  const timeSummary = timeConvert(allTime || 0);

  return {
    workTimeData,
    workTimeWeeklyData,
    weeklyVoluntaryOvertimeLimit,
    weeklyWorktimeLimit,
    timeSummary,
  };
};

export default useWorkTimeLimits;
